import style from './Center.module.scss';

import { ToggleButton } from '@components/ActionButtons/ToggleButton';
import { translate } from '@chaika/i18n/helper';

export interface CenterParams {
    isSelected: boolean;
    onOpenFilters(): void;
}

interface CenterContentProps extends CenterParams {}

export function Center({ isSelected, onOpenFilters }: CenterContentProps) {
    return (
        <div className={style.root}>
            <div className={style.filtersButton}>
                <ToggleButton
                    isSelected={isSelected}
                    label={translate('calendarAndFilters')}
                    onClick={onOpenFilters}
                />
            </div>
        </div>
    );
}
